






import Component from 'vue-class-component';
import { FormContainer } from '@/common/mixin/FormContainer';
import SensorCreateForm from '@/context/sensor/component/form/SensorCreateForm.vue';
import WorkPeriodTemplateForm
  from '@/context/work_period/component/template-form/WorkPeriodTemplateForm.vue';
import { AnomalyRemovalFormModel } from '@/context/calculation/model/AnomalyRemovalFormModel';
import AnomalyRemovalForm from '@/context/calculation/components/AnomalyRemovalForm.vue';

@Component({
  components: {
    AnomalyRemovalForm,
    WorkPeriodTemplateForm,
    SensorCreateForm
  }
})
export default class AnomalyRemovalFormContainer extends FormContainer<AnomalyRemovalFormModel> {
  model: AnomalyRemovalFormModel = new AnomalyRemovalFormModel();

  async formApi(): Promise<AnomalyRemovalFormModel> {
    // return await CalculationApi.instance().form<AnomalyRemovalFormModel>(
    //   AnomalyRemovalFormModel,
    //   this.$route?.params?.id ? { id: this.$route.params.id } : null
    // );
    return Promise.resolve(new AnomalyRemovalFormModel());
  }
}
